import { defineMessages } from 'react-intl';

export const labelMessages = defineMessages({
  exportAsPDF: {
    defaultMessage: 'Export As PDF',
    description: 'Export As PDF'
  },
  printPdf: {
    defaultMessage: 'Print',
    description: 'Print PDF'
  },
  printErrorMessage: {
    defaultMessage: 'Print Data Unsuccessfully sent,try again',
    description: 'Print data unsuccessfully sent to backend'
  },
  printSuccessMessage: {
    defaultMessage: 'Print Data Successfully sent.',
    description: 'Print data successfully sent to backend'
  },
  copies: {
    defaultMessage: 'Copies',
    description: 'label for Copies'
  },
  twoSidedPrinting: {
    defaultMessage: 'Two-sided Printing',
    description: 'label for Two-sided Printing'
  },
  tray: {
    defaultMessage: 'Tray',
    description: 'label for Tray'
  },
  paperSize: {
    defaultMessage: 'Paper Size',
    description: 'label for Paper Size'
  },
  printer: {
    defaultMessage: 'Printer',
    description: 'label for Printer'
  },
  print: {
    defaultMessage: 'Print',
    description: 'Title of Print Dialog'
  },
  printerErrorText: {
    defaultMessage: 'Printer is required',
    description: 'Error Text for Printer field'
  },
  paperSizeErrorText: {
    defaultMessage: 'Paper size is required',
    description: 'Error Text for PaperSize  field'
  },
  trayErrorText: {
    defaultMessage: 'Tray is required',
    description: 'Error Text for Tray field'
  },
  copiesErrorText: {
    defaultMessage: 'Copies are required',
    description: 'Error Text for Copies field'
  },
  placeHolderSelect: {
    defaultMessage: 'Select',
    description: 'Place holder message as Select'
  }
});
